<template>
	<div>
				<v-text-field
				v-model="location.name"
				label="Name"
				></v-text-field>
				<v-select
				v-model="location.description"
				label="Description"
				:items="[
					'The appointment will be held at the following location',
					'The appointment will be held via an easy to use online meeting tool', 
					'The appointment will be held over the phone'
				]"
				></v-select>		
				<v-row>
					<v-col>
						<v-text-field
						v-model="location.address1"
						label="Address Line 1"
						></v-text-field>
					</v-col>
					<v-col>
						<v-text-field
						v-model="location.address2"
						label="Address Line 2"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-text-field
						v-model="location.city"
						label="City, County"
						></v-text-field>
					</v-col>
					<v-col>
						<v-text-field
						v-model="location.postcode"
						label="Postcode"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-text-field
						v-model="location.mapLink"
						label="Location Map Link"
						></v-text-field>
					</v-col>
		</v-row>
			<v-btn
			color="success"
			class="mr-4"
			@click="save"
			>Save
			</v-btn>
 
	</div>
</template>

<script>

export default {
  name: 'EditLocation',
  props: ["location"],
  data: () => ({
		location: {}
    }),
	methods: {
		save() {
			var self = this;
			let update = {};
			for( var key in self.location ){
				update[key] = self.location[key];	
			}
			self.$store.dispatch("updateDoc", {
				action: "update", 
				data: update, 
				doc: "locations/" + self.location.id
			}).then( function(){
				self.message = "Location saved";
				self.clicked = true;
				self.$emit("saved");
			}) 
		}
	},
	mounted: function(){
	}	
};

</script>
